import { GmVet } from 'app/pms/exporter/GmVetExporter';
import { VetoPartner } from 'app/pms/exporter/VetoPartnerExporter';
import { VetoWin } from 'app/pms/exporter/VetoWinExporter';
import { FileMaker } from 'app/pms/exporter/FileMakerExporter';

export const DEFAULT_SPECIES_ALIASES_BY_PMS = {
  [GmVet.CONFIGURATION_KEY]: GmVet.DEFAULT_SPECIES_ALIASES,
  [VetoPartner.CONFIGURATION_KEY]: VetoPartner.DEFAULT_SPECIES_ALIASES,
  [VetoWin.CONFIGURATION_KEY]: VetoWin.DEFAULT_SPECIES_ALIASES,
  [FileMaker.CONFIGURATION_KEY]: FileMaker.DEFAULT_SPECIES_ALIASES,
};
